import { render } from "./WalletExchangeTradesList.vue?vue&type=template&id=877f7818&scoped=true"
import script from "./WalletExchangeTradesList.vue?vue&type=script&lang=js"
export * from "./WalletExchangeTradesList.vue?vue&type=script&lang=js"

import "./WalletExchangeTradesList.vue?vue&type=style&index=0&id=877f7818&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-877f7818"]])

export default __exports__